export enum HomePanelPositionEnum {
  BOTTOM,
  CENTER,
  TOP,
}

export enum HomePanelBackgroundTypeEnum {
  BLUR,
  FOLLOW_BUTTON,
  CUSTOM,
}

export enum CategoryBannerPositionEnum {
  LEFT,
  TOP,
}

export enum CategoryBannerCardShapeEnum {
  RECTANGLE,
  CIRCLE,
}
export enum CategoryBannerCardSizeEnum {
  SMALL,
  LARGE,
}
export enum ItemPageBackgroundTypeEnum {
  COLOUR,
  PATTERN,
}
export enum MenuPageBackgroundTypeEnum {
  CUSTOM,
  PATTERN,
}
export enum ItemPageModifierImageStyleEnum {
  CIRCLE,
  RECTANGLE,
  NO_IMAGE,
}

export enum CategorySizesEnum {
  SMALL,
  MEDIUM,
  LARGE,
  EXTRA_LARGE,
  XX_LARGE,
}
